/**
 * Created by Arif Topcu in 2019
 */

import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ComplicationSelector from '@ls/grouping-complication-selector';
import FactorAttributionDefinition from 'state/factorAttribution/FactorAttributionDefinition';
import {selectDefinitions} from 'state/factorAttribution/selectors';
import FactorAttributionSelectorComplication from './FactorAttributionSelectorComplication';
import SelectionState from 'state/selections/SelectionState';
import {setDefinition as setFactorAttributionDefinitions} from 'state/factorAttribution/actions';

const FactorAttributionSelector = () => {

  const dispatch = useDispatch();
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setFactorAttributionDefinitions(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={FactorAttributionDefinition.getDefault}
      ComplicationComponent={FactorAttributionSelectorComplication}
      btnTitle={"Factor Attribution"}
      addMoreText={'Factor Attribution Column'}
    />
  );
};

export default FactorAttributionSelector;
